import * as React from "react";

export const combineReducers = <F extends React.Reducer<React.ReducerState<F>, React.ReducerAction<F>>>(
    ...args: F[]
) => {
    return (state: React.ReducerState<F>, action: React.ReducerAction<F>) => {
        let newState: React.ReducerState<F>;
        args.forEach(reducer => {
            newState = reducer(newState ?? state, action);
        });
        return newState;
    };
};
